import React, { useEffect } from 'react'
import { useUsersMeQuery } from '@/gql/systemApi'
import { userGuidingService } from '@/services/UserGuiding'
import {
  SessionKey,
  sessionStorageService,
} from '@/services/SessionStorage/SessionStorageService'

interface UserGuidingProviderProps {
  children: React.ReactNode
}

export const UserGuidingProvider: React.FC<UserGuidingProviderProps> = ({
  children,
}) => {
  const { data: userData, loading: userLoading } = useUsersMeQuery()

  const user = userData?.users_me

  useEffect(() => {
    const identifyUser = async () => {
      // Check if user is authenticated
      const token = sessionStorageService.getItem(SessionKey.TOKEN)
      if (!token || !user?.id) {
        return
      }

      const { email } = user

      if (!email) {
        // eslint-disable-next-line no-console
        console.error('UserGuidingProvider: user.email is empty')
        return
      }

      // Identify user in UserGuiding (service prevents duplicate calls within same session)
      await userGuidingService.identify(email)
    }

    if (!userLoading && user) {
      identifyUser()
    }
  }, [user, userLoading])

  return <>{children}</>
}
